import React, { useState, useEffect, createContext, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './header/Header';
import Sidebar from './sidebar/Sidebar';
import SCMap from './map/SCMap';
import LegendApp from './legend/App';
import LayerInfoApp from './layerInfo/App';

import './helpers/SC.css';
import mainConfig from './config.json';
import * as helpers from './helpers/helpers';
import LoadingScreen from './helpers/LoadingScreen.jsx';
import ReactGA from 'react-ga4';
import packageJson from '../package.json';
import LoginScreen from './login/LoginScreen.jsx';

export const UserContext = createContext();
export const AppInfoContext = createContext();

const App = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [appInformation, setAppInformation] = useState({
    reports: { showInfoModal: false, id: null },
    citizenReport: {
      currentStep: 0,
      issueCoordinates: { x: null, y: null },
    },
    maintenance: { currentOption: 0 },
    panorama: {
      currentStep: 0,
      panoramaCoordinates: { x: null, y: null },
    },
    problemManagement: {
      modalUpdate: 0,
      modalActive: false,
      selectedOption: 0,
      id: null,
      workOrderId: null,
      workOrderSerialNumber: null,
      locationModal: false,
      elementSelection: false,
      selectedLayer: null,
      selectedElement: null,
      location: null,
    },
    workOrderReport: {
      modalActive: false,
      problemId: null,
    },
    statistics: {
      active: false,
      statisticsMinimized: false,
      problemModalActive: false,
      data: null,
    },
    waterManagement: {
      showWaterMonitoringMainModal: false,
      waterMonitoringMeasurementId: null,
      selectedMeasurementType: null,
      waterMonitoringData: null,
      monitoringVersion: 0,

      showWaterBalanceMainModal: false,
      waterBalanceData: null,
      waterBalanceVersion: 0,
    },
  });

  const setControlPreferences = () => {
    const localMapControls = helpers.getItemsFromStorage(
      'kontrole vidljivosti'
    );

    if (localMapControls !== undefined) window.mapControls = localMapControls;
    else window.mapControls = mainConfig.controls;
  };
  useEffect(() => {
    const enableAnalytics = helpers.getURLParameter('ANALYTICS') !== 'off';
    // if (
    //   mainConfig.googleAnalyticsID !== undefined &&
    //   mainConfig.googleAnalyticsID !== '' &&
    //   enableAnalytics
    // ) {
    //   ReactGA.initialize(mainConfig.googleAnalyticsID);
    //   ReactGA.send({
    //     hitType: 'pageview',
    //     page: window.location.pathname + window.location.search,
    //   });
    // }
    window.app = packageJson.name;
    window.homepage = packageJson.homepage;
    window.version = packageJson.version;
    setControlPreferences();
  }, []);

  const [loggedIn, setLoggedIn] = useState(false);

  return (
    <UserContext.Provider value={{ userDetails, setUserDetails }}>
      <AppInfoContext.Provider value={{ appInformation, setAppInformation }}>
        <Router>
          <Routes>
            {loggedIn ? (
              <>
                <Route path="/legend" element={<LegendApp />} />
                <Route path="/layerInfo" element={<LayerInfoApp />} />
                <Route path="/public" element={<MapApp />} />
                <Route exact path="/" element={<MapApp />} />
                <Route path="*" element={<MapApp />} />
              </>
            ) : (
              <Route
                path="*"
                element={<LoginScreen setLoggedIn={setLoggedIn} />}
              />
            )}
          </Routes>
        </Router>
      </AppInfoContext.Provider>
    </UserContext.Provider>
  );
};

const MapApp = (props) => {
  const { userDetails } = useContext(UserContext);
  const [mapLoading, setMapLoading] = useState(true);
  const [sidebarLoading, setSidebarLoading] = useState(true);
  const [headerLoading, setHeaderLoading] = useState(true);

  // console.log(userDetails);

  const changeIcon = (icon) => {
    var link = document.getElementById('favicon');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.id = 'favicon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    let urlArray = link.href.split('/');
    urlArray.pop();
    icon = `${urlArray.join('/')}/${icon}`;
    link.href = icon;
  };
  useEffect(() => {
    // LISTEN FOR MAP TO MOUNT
    const mapLoadedListener = () => setMapLoading(false);
    window.emitter.addListener('mapLoaded', mapLoadedListener);
    // LISTEN FOR SIDEBAR TO MOUNT
    const sidebarLoadedListener = () => setSidebarLoading(false);
    window.emitter.addListener('sidebarLoaded', sidebarLoadedListener);
    // LISTEN FOR HEADER TO MOUNT
    const headerLoadedListener = () => setHeaderLoading(false);
    window.emitter.addListener('headerLoaded', headerLoadedListener);

    window.app = packageJson.name;
    window.homepage = packageJson.homepage;
    window.version = packageJson.version;
    const guest = userDetails.guest ? true : false;
    helpers.loadConfig(guest, () => {
      document.title = window.config.title;
      if (window.config.favicon) changeIcon(window.config.favicon);
      helpers.addIsLoaded('settings');
      if (window.config.default_theme !== undefined)
        window.emitter.emit(
          'activateSidebarItem',
          window.config.default_theme,
          'themes'
        );
      if (window.config.default_tool !== undefined)
        window.emitter.emit(
          'activateSidebarItem',
          window.config.default_tool,
          'tools'
        );
    });
    return () => {
      window.emitter.removeListener('mapLoaded', mapLoadedListener);
      window.emitter.removeListener('sidebarLoaded', sidebarLoadedListener);
      window.emitter.removeListener('headerLoaded', headerLoadedListener);
      // headerLoadedListener.remove();
      // sidebarLoadedListener.remove();
      // mapLoadedListener.remove();
    };
  }, []);

  return (
    <div>
      <div id="portal-root" />
      <LoadingScreen
        visible={mapLoading || sidebarLoading || headerLoading}
        backgroundColor={'#3498db'}
      />
      <Header mapLoading={mapLoading} sidebarLoading={sidebarLoading} />
      <Sidebar
        mapLoading={mapLoading}
        headerLoading={headerLoading}
      />
      <SCMap sidebarLoading={sidebarLoading} headerLoading={headerLoading} />
    </div>
  );
};
export default App;
